export const vegetation = [
  '#0d4702',
  '#3b982d',
  '#98be63',
  '#d3c653',
  '#f7c68d',
  '#ee932a',
  '#df3416',
  '#765c34',
  '#0c94e3',
  '#0cc6e3'
]

export const greens2 = ['#e5f6e0', '#c7e9c0', '#a1d99a', '#74c476', '#42ab5d', '#228b44', '#006d2c']

export const viridis = [
  // '#450054',
  // '#424487',
  // '#2a788e',
  // '#20a984',
  // '#7bd251',
  // '#fde723',
  '#fde723',
  '#7bd251',
  '#20a984',
  '#2a788e',
  '#424487',
  '#450054'
]

export const magma = ['#000004', '#2C105C', '#711F81', '#B63679', '#EE605E', '#FCFDBF']
export const contours = ['#fff', '#000']
export const rdYwGn = ['#d7191c', '#fdae61', '#ffffc0', '#a6d96a', '#1a9641']
export const greens = ['#b8d9a9', '#8dbd80', '#5d9d53', '#287a22', '#16692c']
export const esriBanana = ['#beac2d', '#e8d966', '#f5e998', '#cfb489', '#ad8b62', '#664015'] // dif a 20 años
export const da2Yearly = ['#bc0626', '#f03224', '#fe813a', '#fec558', '#ffffac']
export const greensThree = ['#b8d9a9', '#5d9d53', '#16692c']

export const blues = ['#03075e', '#033e8a', '#0177b7', '#0396c7', '#03b5d9', '#48cae4', '#92e0ef', '#aee7f4', '#c9f0f7']
export const bluesThree = ['#03075e', '#03b5d9', '#c9f0f7']

export const alemania = [
  '#9e0208',
  '#d10502',
  '#e95d04',
  '#f48b08',
  '#fb8f07',
  '#fba307',
  '#ffba0b',
  '#ffe30b',
  '#fff70b'
]
export const alemaniaThree = ['#02071d', '#d10502', '#ffba0b']

export const carbonVegPalette = ['#ffffc7', '#ddc88f', '#b9935a', '#82612d', '#4e3300']

export const secondCarbonVegPalette = ['#A4DE02', '#76BA1B', '#4C9A2A', '#ACDF87', '#68BB59']

export const thirdCarbonVegPalette = ['#41C0F2', '#58c7F3', '#70CFF5', '#A0DFF8', '#CFEFFC']

export const thirdCarbonInvertedVegPalette = ['#CFEFFC', '#A0DFF8', '#70CFF5', '#58c7F3', '#41C0F2']

export const waterColorPalette = ['#f3e3d2', '#c8c39e', '#2196f3', '#137fd9', '#0069c0']

export const coverageDep1Palette = ['#f5e1ce', '#e8c39e', '#5ccb5f', '#009929', '#006414']

export const totalDep1Palette = ['#ffff8b', '#c6da52', '#8db600', '#588100', '#255000']

export const colorArbus = ['#FFFFFF05', '#ffaf7a', '#ff9d5c', '#ff8b3d', '#ff781f']

export const colorDen = ['#FFFFFF05', '#e1affd', '#ca8dfd', '#c175ff', '#b042ff']

export const colorDes = ['#FFFFFF05', '#BFDAD7', '#A0C8C3', '#7AB4AD', '#1C9997']

export const colorHab = ['#FFFFFF05', '#DBE4A9', '#C3D48B', '#95B634', '#8AAD34']
